import axios from 'axios';

import Page from './page';
import Person from './person';
import Component from './component';
import CTO from './cto';
import SEO from './seo';
import { useRelativeLink, isNode, contextParameterInterceptor } from '../util';
import { Helpers } from '../helpers';

export const EtrAPIClient = function (domain = 'uat3live.store.hp.com', httpConfig = {}) {
    let self = this;
    let config = {
        siteInfo: {
            langId: -1,
            storeId: 10151,
            catalogId: 10051,
        },
    };
    let etrWCSInstance = axios.create({
        baseURL: useRelativeLink() ? '' : `https://${domain}`,
        //set a longer timeout for browser side call
        timeout: isNode ? 50000 : 60000 * 2,
        ...httpConfig,
    });

    //debug
    etrWCSInstance.interceptors.request.use(httpConfig => {
        const { baseURL, url } = httpConfig;
        const queryString = Helpers.paramsToString(httpConfig.params);
        const { location } = typeof document !== 'undefined' ? document : {};
        const { origin } = location || {};
        //TODO: temp prevent any traffic in prod till API are ready
        if (
            (baseURL || '').indexOf('www.hp.com') > -1 ||
            (origin || '').indexOf('www.hp.com') > -1 ||
            (url || '').indexOf('www.hp.com') > -1
        ) {
            throw new Error(`WCS API NOT YET AVAILABLE ON ${baseURL}`);
        }
        console.log(`${httpConfig?.url}${queryString ? `?${queryString}` : ''}`);
        httpConfig = contextParameterInterceptor(httpConfig);
        return httpConfig;
    });

    self.page = new Page(config, etrWCSInstance);
    self.person = new Person(config, etrWCSInstance);
    self.component = new Component(config, etrWCSInstance);
    self.seo = new SEO(config, etrWCSInstance);
    self.cto = CTO(self, config, etrWCSInstance);
    self.httpInstance = etrWCSInstance;
};

const _EtrAPI = new EtrAPIClient();

//TEMP: for debugging
if (typeof window !== 'undefined' && !isNode) {
    window.EtrAPI = _EtrAPI;
}

export default _EtrAPI;
